$(function(){
    $('.js-trigger-filters').on('click', function(){

        $('.sidebar').addClass('sidebar--overlay');
        $('body').addClass('no-scroll');
    })

    $('.js-close-filters').on('click', function(){
        $('.sidebar').removeClass('sidebar--overlay');
        $('body').removeClass('no-scroll');
    })
})